import { render, staticRenderFns } from "./search-popup.vue?vue&type=template&id=46ab4d66&shadow"
import script from "./search-popup.vue?vue&type=script&lang=js&shadow"
export * from "./search-popup.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports